<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <sarala-table
                    :model="model"
                    :headers="headers"
                    ref="table"
                    :topLeftColumns="4"
                    :searchColumns="8"
                    :draggableTable="true"
                    @reorder="reorder"
                >
                    <template #create-btn>
                        <div class="pa-3">
                            <v-btn
                                color="indigo"
                                class="white--text"
                                @click="newItem"
                            >
                                {{ $t('tags.form.buttons.create') }}
                            </v-btn>
                        </div>
                    </template>

                    <template #draggable>
                        <v-icon x-small class="grab-icon">
                            mdi-drag-vertical
                        </v-icon>
                    </template>

                    <template #action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="editItem(item)"
                                >
                                    <v-icon color="blue-grey" v-on="on"
                                        >mdi-pencil</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('form.actions.edit') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="deleteItem(item)"
                                >
                                    <v-icon color="red" v-on="on"
                                        >mdi-close</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('form.actions.delete') }}</span>
                        </v-tooltip>
                    </template>
                </sarala-table>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" max-width="600px">
            <v-form ref="form" v-if="tag" @submit.prevent="save">
                <v-card>
                    <card-header
                        :title="$t('tags.form.buttons.create')"
                        :showBackButton="false"
                    ></card-header>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        label="Tag"
                                        v-model="tag.title"
                                        ref="tagTitle"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <form-actions
                        :loadingSave="loading"
                        :showBackButton="false"
                    >
                        <template #middle>
                            <v-btn color="grey" @click="dialog = false" text>
                                {{ $t('tags.form.buttons.close') }}
                            </v-btn>
                        </template>
                    </form-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <confirm ref="confirm_remove" width="500px"></confirm>
    </v-container>
</template>

<script>
import Tag from '@/models/Tag'
import SaralaTable from '@/shared/components/SaralaTable'
import Confirm from '@/components/dialogs/Confirm'
import CardHeader from '@/components/utils/CardHeader'
import FormActions from '@/components/utils/FormActions'

export default {
    components: {
        'sarala-table': SaralaTable,
        confirm: Confirm,
        'card-header': CardHeader,
        'form-actions': FormActions,
    },

    data: () => {
        return {
            loading: false,
            dialog: false,
            tag: null,
        }
    },

    computed: {
        model() {
            return new Tag()
        },

        headers() {
            return [
                {
                    text: '',
                    value: 'draggable',
                    sortable: false,
                    width: 30,
                },
                {
                    text: 'Tag',
                    value: 'title',
                    sortable: false,
                },
                {
                    text: this.$t('tables.actions'),
                    value: 'action',
                    width: 150,
                    sortable: false,
                    align: 'end',
                },
            ]
        },
    },

    methods: {
        newItem() {
            this.tag = new Tag()
            this.dialog = true
        },

        editItem(item) {
            this.tag = item
            this.dialog = true
        },

        async deleteItem(item) {
            let confirm = await this.$refs.confirm_remove.open(
                this.$t('tags.index.messages.delete'),
                this.$t('tags.index.messages.delete-confirmation', {
                    tag: item.title,
                }),
            )

            if (!confirm) return

            let clone = item.clone()

            let res = await clone.delete().catch(() => {})

            if (!res) return

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('tags.index.messages.delete-success', {
                    tag: item.title,
                }),
            )

            this.$emit('edited')
        },

        async save() {
            let clone = this.tag.clone()

            let res = null

            try {
                res = await clone.save().catch(() => {})
            } finally {
                this.loading = false
            }

            if (!res) return

            this.dialog = false

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('tags.form.bus.save-success', {
                    tag: clone.title,
                }),
            )

            this.$refs.table.getItems()

            this.$emit('edited')
        },

        async reorder(items) {
            await this.model.reorder(items)
        },
    },
}
</script>
